import { type IWidgetDirectiveType } from '@framework/engine/schema/directives/IWidgetDirectiveType.ts';
import { isInputWidget } from '@framework/engine/schema/widgets/repository/inputs/isInputWidget.ts';
import { WidgetType } from '@framework/engine/schema/widgets/Widget.ts';
import { FormBuilderMetaFlags } from '@framework/engine/validator/form-builder/flags/FormBuilderMetaFlags.ts';
import {
  type IMetadataDirective,
  type IMetadataDirectiveSchemaMeta,
  MetadataDirectiveSchema,
} from './IMetadataDirective.ts';
import { MetadataDirectiveConfigComponent } from './MetadataDirectiveConfigComponent.tsx';

/**
 * Direttiva per l'esportazione dei metadati di un campo in forma
 * normalizzata.
 */
export const MetadataDirectiveType: IWidgetDirectiveType<IMetadataDirective> = {
  name: 'metadata',
  key: 'metadata',
  allowsWidget: (widget, widgetType) =>
    isInputWidget(widget) && widget.type !== WidgetType.Repeatable,
  configComponent: MetadataDirectiveConfigComponent,
  configSchema: MetadataDirectiveSchema,
  formSchemaModifier: ({
    directiveConfig,
    schema,
    widget,
    widgetType,
    flags,
  }) => {
    if (!directiveConfig.enabled && !directiveConfig.semanticTag) {
      return schema;
    }

    if (
      flags[FormBuilderMetaFlags.SkipValidationRules] ||
      flags[FormBuilderMetaFlags.SkipExportMetadata]
    ) {
      return schema;
    }

    // Salviamo il tipo del campo da esportare nei meta, così da accedervi
    // in fase di estrazione
    const directiveMetadata: IMetadataDirectiveSchemaMeta = {
      export: Boolean(directiveConfig.enabled),
      searchable: !!directiveConfig.searchable,
      type: schema.type,
      widgetId: widget.id,
      widgetType: widgetType.type,
      semanticTag: directiveConfig.semanticTag,
    };
    return schema.meta?.({
      directiveMetadata,
    });
  },
  supportedSectionTypes: ['BACKOFFICE', 'FRONTOFFICE'],
};
